"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestAssertSink = void 0;
const types_1 = require("./types");
const initialLogEntries = {
    debug: [],
    info: [],
    warn: [],
    error: [],
};
const defaultMaxLevel = { maximumLevel: "warn" };
/**
 * TestAssertSink is a test sink that you can use to validate the behaviour of
 * Logs in your test code. Usage of it is wrapped up by mockLogger, so you
 * should not need to interact with a TestAssertSink directly.
 *
 * It works by you stating a maximum allowed LogLevel, after which it will
 * receive logEntries, and if it receives one that is above the max, it will
 * throw an error. This error will bubble up and should fail your test,
 * alerting you to the need to fix/change something.
 *
 * The default maximumLevel is "warn".
 */
class TestAssertSink extends types_1.LogSink {
    get entries() {
        return this.logEntries;
    }
    /**
     * Create a TestAssertSink to ensure you don't have any unexpected Logs in tests
     */
    constructor({ maximumLevel } = defaultMaxLevel) {
        super({ maximumLevel });
        this.logEntries = Object.assign({}, initialLogEntries);
    }
    next(logEntry) {
        const level = logEntry.level;
        if (this.shouldHandleLogEntry(logEntry)) {
            this.logEntries[level] = [...this.logEntries[level], logEntry];
        }
        else {
            throw new types_1.TestAssertUnexpectedLogError(`Unexpected Log.${level} in test. If you expected this Log.${level} to occur, pass { maximumLevel: ${level} } when constructing TestAssertSink.`);
        }
    }
}
exports.TestAssertSink = TestAssertSink;
//# sourceMappingURL=TestAssertSink.js.map